import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {Router} from '@angular/router';
import {CardService} from '../../shared/card.service';
import {MeetingService} from '../../shared/meeting.service';
import {RecensioniService} from '../../shared/recensioni.service';

@Component({
  selector: 'app-meeting',
  templateUrl: './meeting.component.html',
  styleUrls: ['./meeting.component.css']
})
export class MeetingComponent implements OnInit {
  constructor(public afAuth: AngularFireAuth , public router: Router, private meetingService: RecensioniService) {
  }
  linki;
  ngOnInit() {
    this.ReturnMeeting();
    console.log(this.linki);
    this.afAuth.onAuthStateChanged((us) => {
      if (us) {
        this.router.navigate(['meeting']);
      } else {
        this.router.navigate(['']);
      }
    });
}


  logout() {
    this.afAuth.signOut().then(() => {
      this.router.navigate(['']);
    });
  }

  ReturnMeeting = () => this.meetingService.getLink()
      .subscribe(res => (this.linki = res))




}





